import { useSelector } from "react-redux";
import React, { useEffect } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography,
} from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Refresh";
import OrderApi from "api/OrderApi";

type Props = {
  formData: any;
  onChange(key: string): any;
  onChangePrice(key: string): any;
  onChangeCheckBox(key: string): any;
};

const OrderDriver: React.FC<Props> = ({
  formData,
  onChange,
  onChangePrice,
  onChangeCheckBox,
}) => {
  const companyId = useSelector((state) => state.account.staff.companyId);
  const driverShifts = useSelector((state) => state.driverShift);

  useEffect(() => {
    onChangePrice("outwardDriver")(
      driverShifts.find(
        (driverShift) => driverShift.driverId === formData?.outwardDriverId
      )?.driver || null
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData?.outwardDriverId]);

  useEffect(() => {
    onChangePrice("returnDriver")(
      driverShifts.find(
        (driverShift) => driverShift.driverId === formData?.returnDriverId
      )?.driver || null
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData?.returnDriverId]);

  const onClickReloadDriver = async () => {
    const order = await OrderApi.findOne(companyId, formData?.orderId);
    onChangePrice("outwardDriverId")(order?.outwardDriverId || null);
    onChangePrice("returnDriverId")(order?.returnDriverId || null);
  };

  return (
    <Paper variant="outlined" style={{ padding: 12, marginTop: 8 }}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={1}
      >
        <Typography variant="subtitle1">配車</Typography>
        {formData?.orderId && (
          <Button
            size="small"
            startIcon={<RefreshIcon fontSize="small" />}
            onClick={async (event) => {
              event.persist();
              await onClickReloadDriver();
            }}
          >
            最新に更新
          </Button>
        )}
      </Box>

      <Box display="flex" style={{ gap: 8 }}>
        <FormControl size="small" variant="outlined" fullWidth>
          <InputLabel id="outwardDriverId-label">送りドライバー</InputLabel>
          <Select
            labelId="outwardDriverId-label"
            label="送りドライバー"
            value={formData["outwardDriverId"] || ""}
            onChange={onChange("outwardDriverId")}
          >
            <MenuItem value="">
              <em>未アサイン</em>
            </MenuItem>
            {driverShifts?.map((driverShift) => (
              <MenuItem
                value={driverShift?.driverId}
                key={driverShift?.driverId}
              >
                {driverShift?.driver?.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" variant="outlined" fullWidth>
          <InputLabel id="returnDriverId-label">迎えドライバー</InputLabel>
          <Select
            labelId="returnDriverId-label"
            label="迎えドライバー"
            value={formData["returnDriverId"] || ""}
            onChange={onChange("returnDriverId")}
          >
            <MenuItem value="">
              <em>未アサイン</em>
            </MenuItem>
            {driverShifts?.map((driverShift) => (
              <MenuItem
                value={driverShift?.driverId}
                key={driverShift?.driverId}
              >
                {driverShift?.driver?.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box display="flex" alignItems="center" mt={1} style={{ gap: 4 }}>
        <Typography variant="caption" color="textSecondary">
          配車要否:
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              color="primary"
              onChange={onChangeCheckBox("isUseOutward")}
              checked={Boolean(formData["isUseOutward"])}
            />
          }
          label="送り"
        />
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              color="primary"
              onChange={onChangeCheckBox("isUseReturn")}
              checked={Boolean(formData["isUseReturn"])}
            />
          }
          label="迎え"
        />
      </Box>
    </Paper>
  );
};
export default OrderDriver;
